module.exports = __webpack_public_path__ + "static/media/playstore.0935415c.png";